import Loadable from 'react-loadable'

export default Loadable({
  loader: () => import(/* webpackChunkName: "statement" */ './index'),
  loading: () => null,
})
